// @wf-will-never-add-flow-to-this-file

import {emotionStyled} from '@packages/utilities/styled';
import {RadioCard} from '@packages/systems/spring';
import {brandedFontFamily} from '../../constants';

/**
 * `emotionStyled` types are having trouble composing the inferred generic types from `Select` when returning the curried styled component.
 * So, we will just manually set it for now.
 */
/**
 * @deprecated Use Spring `RadioCard` from `@packages/systems/spring` instead.
 * `BrandedRadioCard` only adds branded padding and text styles on top of the
 * standard `RadioCard`. Wrap `RadioCard` with `emotionStyled` for the padding,
 * and pass the branded typography in via the `label` prop:
 *
 * ```tsx
 * const RadioCardView = emotionStyled(RadioCard)({padding: '$4 $3'});
 *
 * <RadioCardView label={<Text font="brandedBody">Yes</Text>} />
 * ```
 */
// @ts-expect-error - TS2322 - Typescript is having trouble inferring the generic types and ref types here. We need to clean up the emotionStyled type inferences to resolve this.
export const BrandedRadioCard: typeof RadioCard = emotionStyled(RadioCard)({
  padding: '$4 $3',
  '[data-sc="Text"]': {
    fontFamily: brandedFontFamily,
    fontSize: '14px',
    lineHeight: '24px',
  },
});

BrandedRadioCard.displayName = 'BrandedRadioCard';
